import { useTranslation } from 'utils/use-translation'
import ContentHeader from '../../../components/ui/account/content/__header'
import { useHeader } from '../../../utils/use-header'
import CashOutPage from '../cash-out'

import styles from './styles.module.scss'

const BuySell = () => {
  const { t } = useTranslation()
  const head = useHeader(t('buy_sell'))

  return (
    <>
      {head}
      <ContentHeader className={styles.header} title={t('buy_sell')}></ContentHeader>
      <CashOutPage />
    </>
  )
}
export default BuySell
